module.exports = __webpack_public_path__ + "img/7057054.1dc49795.jpg";